import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {FormattedMessage} from 'react-intl';
import ShareBar from '../../cmp/ShareBar';
import {connect, useDispatch, useSelector} from 'react-redux';
import RenderCommission from '../../cmp/RenderCommission';
import {PencilIcon} from '../../../icons/Icons';
import useToggle from '../../cmp/hooks/useToggle';
import Modal from '../../cmp/Modal';
import {post} from '../../../api';
import {buildRefLink} from '@goaffpro/aff-client-commons/functions';
import {actionMergeSetting} from '../../../redux/settings/settingsAction';
import useRefLink from '../../cmp/hooks/useRefLink';

function ReferralLink({ref_link, status, commission_type, commission_value}) {
    const [        ref_change_allowed, multi_ref_codes] = useSelector((state)=>[
        state.settings.ref_change_allowed,
        state.settings.multi_ref_codes,
    ])

    return (<div className={'mb-4'}>
        <h4>
            <FormattedMessage id={'referralLink'} defaultMessage={'Referral Link'}/>
            {
                Number(commission_value) > 0 ?
                <span className="ml-2 badge badge-secondary referralLinkBadge">
                    <FormattedMessage id={"referralLinkBadge"}
                          values={{
                              commission_value: <RenderCommission commission_type={commission_type} commission_value={commission_value} />
                          }}
                    />
                </span>
                    : null
            }
        </h4>
        <p className={'text-muted'}>
            <FormattedMessage id={'referralLinkDesc'}
              values={{
                  commission_value: <RenderCommission commission_type={commission_type} commission_value={commission_value} />
              }}
            />
        </p>

        {
            ['approved', 'invited'].indexOf(status) > -1 && <div>
                {
                    <p><a style={{whiteSpace:'pre-line',wordBreak:'break-all'}} rel={"noopener noreferrer nofollow"} href={ref_link} target={'_blank'}>{decodeURI(ref_link)}</a></p>
                }
                <div className={"d-flex align-items-center "}>
                    <ShareBar link={ref_link}/>
                    {
                        ref_change_allowed && !multi_ref_codes ?
                            <ReferralLinkEditor/> : null
                    }
                </div>
                <RenderPrimaryQuickLinks />
            </div>
        }
        {
            status === 'pending' && <p className={'alert alert-warning'}>
                <FormattedMessage id={'Account under review'}/></p>
        }
    </div>);
}

function RenderPrimaryQuickLinks(){
    const quick_links = useSelector((state)=>{
        const ql = state.settings.quick_links
        if(ql){
            return ql.filter(({isPrimary})=>isPrimary)
        }
    })
    if(!quick_links || quick_links.length === 0){
        return null
    }

    return (
        <div>
            <>
                {
                    quick_links.map((item)=>{
                        return <RenderLink key={item.id} title={item.title} url={item.url} />
                    })
                }
            </>
        </div>
    );
}

function RenderLink({title, url}){
    const [ref_link] = useRefLink(url)
    return  <>
            <hr/>
        {
            <p><a style={{whiteSpace:'pre-line',wordBreak:'break-all'}}
                  rel={"noopener noreferrer nofollow"} href={ref_link}
                  title={title}
                  target={'_blank'}>{decodeURI(ref_link)}</a></p>
        }
        <div className={"d-flex align-items-center "}>
            <ShareBar link={ref_link}/>
        </div>
    </>
}


const replacer = /[^A-z0-9~_.-]/ig
function ReferralLinkEditor(){
    const [website, ref_code, ref_identifiers,] = useSelector((state)=>[state.settings.website,
        state.settings.ref_code, state.settings.ref_identifiers])

    const w = useMemo(()=>{
        return website  && website.startsWith("https") ? website : `https://${website}`
    },[website])
    const [refCode, setRefCode] = useState('')
    useEffect(()=>{
        setRefCode(ref_code)
    },[ref_code])
    const [visible, toggle] = useToggle(false)
    const [saving, setSaving] = useState(false)
    const [error, setError] = useState(null)
    const setRef = useCallback((e)=>{
       setRefCode(e.target.value.replace(replacer, '').trim())
    },[])
    const codes = useMemo(()=>{
        return refCode.split("\n").map((i)=>i.trim()).filter((i)=>i)
    },[refCode])
    const dispatch = useDispatch()
    const onSubmit = useCallback((e)=>{
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }
            setSaving(true)
            post('/referral_codes', {
                referral_codes:codes
            }).then((data) => {
                setSaving(false)
                if (data.codes) {
                    dispatch(actionMergeSetting({ref_code: data.codes[0]}));
                    toggle()
                } else if (data.conflicts) {
                    setError('Referral code is already in use');
                } else {
                   setError('Network error');
                }

            }).catch((e) => {
                setSaving(false)
            });
    },[codes, dispatch, toggle])
    return <>
        <button onClick={toggle} className="btn btn-link text-muted">
            <PencilIcon />
        </button>
        <Modal
            confirmLoading={saving}
            disabled={refCode === ref_code || (!codes || codes.length === 0)}
            visible={visible} okText={<FormattedMessage id={"Submit"} />} onSubmit={onSubmit} onCancel={toggle} title={<FormattedMessage id={"referralCode"} />}>
        <p><FormattedMessage id={"referralCodeDesc"} /></p>
        <small>
            <strong>{buildRefLink(refCode, w, ref_identifiers)}</strong>
        </small>
        <input  className={"form-control"} value={refCode} onChange={setRef}/>
            {
                error ? <p className="alert alert-danger">{error}</p> : null
            }
    </Modal>
    </>
}

function mapStateToProps(state){
    const {standard} = state.commissions;
    return standard || {}
}

export default connect(mapStateToProps)(ReferralLink);
